import { ApolloError } from "@apollo/client";

export interface CompanySignatureResult {
  success: boolean;
  errorMessage?: string;
}

const USER_FACING_ERROR_CODES = [
  "LEGAL_REPRESENTATIVES_UNAVAILABLE",
  "FORBIDDEN",
  "BAD_USER_INPUT",
];

export const toCompanySignatureError = (
  error: unknown,
): CompanySignatureResult => {
  console.error(error);
  const graphQLError =
    error instanceof ApolloError ? error.graphQLErrors[0] : undefined;
  const code = graphQLError?.extensions?.code as string | undefined;
  return {
    success: false,
    errorMessage:
      code && USER_FACING_ERROR_CODES.includes(code)
        ? graphQLError?.message
        : undefined,
  };
};
